import type { FaceDetectionResponse } from "@yujacorp/inference-ambassador";

export const computeGazeDirection = (face: FaceDetectionResponse["faces"][number]): string => {
	const getHorizontalDirection = () => {
		if (face.rotation.yaw >= 12.0) return "left";
		if (face.rotation.yaw <= -12.0) return "right";
	};

	const getVerticalDirection = () => {
		if (face.rotation.pitch >= 12.0) return "up";
		if (face.rotation.pitch <= -12.0) return "down";
	};

	const horizontalDirection = getHorizontalDirection();
	const verticalDirection = getVerticalDirection();

	if (!horizontalDirection || !verticalDirection) return "center";
	return `${verticalDirection}-${horizontalDirection}`;
};
